import $ from "jquery"

$('.js-system-item-label').each(function(){
    $(this).on('click', function(){
        const systemDescription = $(this).closest('.js-system-item-list').find('.systems__item-description').html();

        $('.js-system-item-description').html(systemDescription);
        $('.js-system-item-list').removeClass('active');
        
        $(this).closest('.js-system-item-list').addClass('active');
    });
});